import {
  Box,
  Card,
  CardContent,
  Container,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { PageTitle } from "../../commanComponents/PageTitle";
import { String } from "../../constants/Strings";
import { LinearProgressBar } from "../../commanComponents/LinearProgressBar";
import { getColor } from "../../style/color/color";
import ACRButton from "../../commanComponents/ACRButton";
import { useLocation, useNavigate } from "react-router-dom";
import CustomSnackbar from "../../commanComponents/CustomerSnackbar";
import { goalArray } from "../../constants/GoalArray";
import { DataContext } from "../../Hooks/context/ChildData";
import { useSavingGoals } from "../../api/apiEndpoints/SavingGoals";
import { Info } from "@mui/icons-material";
import { fonts } from "../../style/fonts/fonts";
import { gaCustomEvent } from "../../logic/CommonFunctions";
import { OTPVerifyContext } from "../../Hooks/context/OTPVeriryContext";

const Goal = () => {
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarmessage, setSnackbarMessage] = useState({
    message: "",
    severity: "",
  });
  const navigation = useNavigate();
  const { collectData } = useContext(DataContext);
  const { verifyData } = useContext(OTPVerifyContext);
  const location = useLocation();
  const { getGoals } = useSavingGoals();

  const { state } = location;

  //fetch saved goals when user come back for edit goals
  useEffect(() => {
    if (state && state.someCondition) {
      fetchDataBasedOnState();
    }
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fetchDataBasedOnState = async () => {
    try {
      const response = await getGoals({
        userId: state.userId,
      });
      if (response.httpCode === 200) {
        const selectedGoals = response.response.goals;

        const selectedIndices = selectedGoals
          .flatMap((goal) => {
            const matchedIndices = [];

            // Match by Title
            const titleIndex = goalArray.findIndex(
              (item) => item.Title === goal.goalName
            );
            if (titleIndex !== -1) {
              matchedIndices.push(titleIndex);
            }

            // If goalId === 2, add ALL items with id === 2
            if (goal.goalId === 2) {
              goalArray.forEach((item, index) => {
                if (item.id === 2 && !matchedIndices.includes(index)) {
                  matchedIndices.push(index);
                }
              });
            }

            return matchedIndices;
          })
          .filter((index, i, arr) => arr.indexOf(index) === i); // remove duplicates

        setSelectedIndex(selectedIndices);

        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.Goal.DataFetchSuccessfully,
          severity: String.successSeverity,
        });
      } else {
        setSnackbarOpen(true);
        setSnackbarMessage({
          message: String.Goal.erroWhileFetching,
          severity: String.ErrorSeverity,
        });
      }
    } catch (error) {
      // Handle API call error
      setSnackbarMessage({
        message: String.Goal.erroWhileFetching,
        severity: String.ErrorSeverity,
      });
      setSnackbarOpen(true);
    }
  };

  //For selecting goal card
  const handleCardClick = (index) => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioFinancialGoals, verifyData.customerId);

    setSelectedIndex((prevSelect) => {
      if (prevSelect.includes(index)) {
        return prevSelect.filter((i) => i !== index);
      } else {
        return [...prevSelect, index];
      }
    });
  };

  //Navigate to particular goal selection
  const navigateToSave = (selectedGoals, multiGoal) => {
    //navigate to child journey
    const navigateToChildPlanning = (childPlanningData) => {
      return navigation(String.navigations.childplanning, {
        state: {
          childPlanningData,
          multipleGoal: multiGoal,
        },
      });
    };

    // If only the 1st goal is selected
    if (selectedGoals.length === 1 && selectedGoals[0] === 1) {
      return navigateToChildPlanning(false);
    }
    // If all goals 1st, 2nd, 3rd, 4th, and 5th are selected
    else if (
      selectedGoals.includes(1) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(5) &&
      selectedGoals.includes(4)
    ) {
      return navigateToChildPlanning(true);
    }
    // If all goals 1st, 2nd, 3rd, 4th,  are selected
    else if (
      selectedGoals.includes(1) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(4)
    ) {
      return navigateToChildPlanning(true);
    }
    // If all goals 1st, 2nd, 3rd, and 5th are selected
    else if (
      selectedGoals.includes(1) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(2) &&
      selectedGoals.includes(5)
    ) {
      return navigateToChildPlanning(true);
    }
    // If 1st goal is selected along with 4th or 5th goal
    else if (
      selectedGoals.includes(1) &&
      (selectedGoals.includes(4) || selectedGoals.includes(5))
    ) {
      return navigateToChildPlanning(false);
    }

    // If 1st, 2nd, or 3rd goal is selected, or 2nd and 3rd are selected
    else if (
      selectedGoals.includes(1) ||
      selectedGoals.includes(2) ||
      selectedGoals.includes(2)
    ) {
      return navigateToChildPlanning(true);
    }

    // If the 5th goal is selected
    else if (selectedGoals.includes(5)) {
      return navigation(String.navigations.retirementgoal);
    }

    // If the 4th goal is selected
    else if (selectedGoals.includes(4)) {
      return navigation(String.navigations.investmentgoal);
    }

    // Default case
    else {
      setSnackbarOpen(true);
      setSnackbarMessage(String.Goal.unknownGoalSelected);
    }
  };

  //Save goal with sort goal index based on id which is selected
  const saveGoal = async () => {
    gaCustomEvent(String.gaEventName.acrPortfolio, String.gaEventClickName.acrPortfolioFinancialGoalsContinue, verifyData.customerId);

    if (selectedIndex.length === 0) {
      setSnackbarOpen(true);
      setSnackbarMessage({
        message: String.Goal.atleastGoalSelection,
        severity: String.ErrorSeverity,
      });
      return;
    }

    const selectedGoalsIndex = selectedIndex.map((index) => goalArray[index]);

    const selectedGoals = [
      ...new Set(selectedGoalsIndex.map((goal) => goal.id)),
    ].sort((a, b) => a - b);

    let multiGoal = selectedGoals.length > 1;

    collectData({
      selectedGoals: selectedGoals.includes(2)
        ? [...selectedGoals, 3]
        : selectedGoals,
    });

    setSnackbarOpen(true);
    setSnackbarMessage({
      message: String.Goal.goalSave,
      severity: String.successSeverity,
    });

    setTimeout(() => {
      setSnackbarOpen(false);

      navigateToSave(selectedGoals, multiGoal);
    }, 2000);
  };
  return (
    <Container>
      <PageTitle PageTitle={String.Goal.Title}></PageTitle>
      <LinearProgressBar
        dragMessage={String.Goal.dragMessage}
        progress={32}
        progressNumber={32}
        stepNumber={2}
      />
      <Stack
        sx={{
          width: "100%",
          height: "100%",
          mb: "10px",

          overflowY: "auto",
        }}
      >
        {goalArray.map((item, index) => {
          const IsSelected = selectedIndex.includes(index);
          return (
            <Card
              key={index}
              sx={{
                minWidth: 275,
                borderRadius: "12px",
                border: IsSelected
                  ? `1px solid ${getColor.SecondarySummerSky}`
                  : "1px solid #B9BBC0",
                Color: IsSelected
                  ? getColor.SecondarySummerSky
                  : getColor.NeutralDark700,
                mt: "30px",
                cursor: "pointer",
                boxShadow: "0px 4px 12px rgba(53, 151, 236, 0.20)",
              }}
              onClick={() => handleCardClick(index)}
            >
              <CardContent
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    mt: "10px",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "16px",
                      fontFamily: fonts.manrope,
                      fontWeight: "700",
                      color: IsSelected
                        ? getColor.SecondarySummerSky
                        : getColor.NeutralDark700,
                      alignItems: "center",
                    }}
                  >
                    {item.Title}
                    <Tooltip
                      title={item.tooltip}
                      enterTouchDelay={-5000}
                      leaveTouchDelay={5000}
                    >
                      <IconButton>
                        <Info
                          sx={{
                            width: 12,
                            height: 12,
                            fontSize: "1rem",
                            color: getColor.Grey,
                            fontFamily: fonts.manrope,
                            fontWeight: "700",
                          }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Typography>
                </Box>
                <Box
                  sx={{
                    maxWidth: "100%",
                    height: "auto",
                  }}
                >
                  {item.goalSVG && (
                    <item.goalSVG
                      style={{
                        width: "95px",
                        height: "auto",
                      }}
                    />
                  )}
                </Box>
              </CardContent>
            </Card>
          );
        })}
      </Stack>

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <ACRButton
          label={String.continue}
          style={{
            width: "100%",
            height: "60px",
            maxWidth: "350px",
            backgroundColor: getColor.ColorButtonPrimarysurface,
            color: getColor.PrimaryWhite,
            borderRadius: "40px",
            p: "10px",
            mt: "40px",
            mb: "40px",
            lineHeight: "22.2px",
            fontWeight: 700,
            fontSize: "16px",
            textAlign: "center",
            textTransform: "initial",
          }}
          onClickButton={saveGoal}
        />
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => {
          setSnackbarOpen(false);
        }}
        message={snackbarmessage.message}
        severity={snackbarmessage.severity}
      />
    </Container>
  );
};

export default Goal;
